import React from 'react'
import Image from 'next/image'

interface TrustPilotStaticReviewsProps {
    width: number
    onClick?: () => void
    isAboveTheFold?: boolean // determines if the image loads eagerly with high fetch priority
}

// When to set isAboveTheFold to true?
// It loads the image eagerly with fetchPriority="high" to improve LCP performance
// Only use for images above the fold(hero section, header logos)
// Avoid setting it on all images — it can hurt performance

export default function TrustpilotStaticReviews({ width = 80, onClick, isAboveTheFold = false }: TrustPilotStaticReviewsProps) {
    // calculate height dynamically based on aspect ratio
    const height = Math.round(width / 1.585)
    return (
        <a
            href="https://uk.trustpilot.com/review/zuto.com"
            target="_blank"
            rel="noreferrer"
            onClick={onClick}
            data-testid="trustpilot"
            style={{ height: '40px' }}
        >
            <Image
                src="https://cdn.zuto.cloud/assets/images/trustpilot/Trustpilot_currentReviews.svg"
                alt="Trustpilot reviews"
                aria-label="Trustpilot reviews"
                width={width}
                height={height}
                style={{ width: `${width}px`, height: 'auto' }}
                fetchPriority={isAboveTheFold ? 'high' : undefined}
                loading={isAboveTheFold ? 'eager' : 'lazy'}
            />
        </a>
    )
}